import React, {useState, useRef} from 'react';

import PaymentAPI from 'service/api/PaymentAPI';
import AppConstants from 'AppConstants';

import {Button} from 'views/AppElements';

const VisaCheckoutForm = ({amount, orderIds}) => {
    const [signRes, setSignRe] = useState({});
    const [signature, setSignature] = useState("");
    const visaForm = useRef();

    const onVisaFormSubmit = (event) => {
        event.preventDefault();

        //cal api to sign the pay request and 
        PaymentAPI.signPaymentReq(orderIds, amount, (success, res) => {

            if(success === true) {
                setSignRe(res.signReq);
                setSignature(res.signature);

                visaForm.current.submit();
            }
        });
        
    }

    return <form id="cardPaymentConfirmation" action={AppConstants.CYBERSOURCE_FORM_URL} 
                method="post" onSubmit={onVisaFormSubmit} ref={visaForm}>
            
            <input type="hidden" id="profile_id" name="profile_id" value={signRes.profileId || ''} />
            <input type="hidden" id="transaction_uuid" name="transaction_uuid" value={signRes.transactionUUID || ''} />
            <input type="hidden" id="signed_field_names" name="signed_field_names" value={signRes.signedFieldNames || ''} />
            <input type="hidden" id="unsigned_field_names" name="unsigned_field_names" value={signRes.unsignedFieldNames || ''} />
            <input type="hidden" id="signed_date_time" name="signed_date_time" value={signRes.signedDateTime || ''} />
            <input type="hidden" id="locale" name="locale" value={signRes.locale || ''} />
            <input type="hidden" id="amount" name="amount" value={signRes.amount || ''} />
            <input type="hidden" id="transaction_type" name="transaction_type" value={signRes.transactionType || ''} />

            <input type="hidden" id="reference_number" name="reference_number" value={signRes.referenceNumber || ''} />
            <input type="hidden" id="currency" name="currency" value={signRes.currency || ''} />
            <input type="hidden" id="access_key" name="access_key" value={signRes.accessKey || ''} />
            
            <input type="hidden" id="payment_method" name="payment_method" value={signRes.paymentMethod || ''} />
            <input type="hidden" id="signature" name="signature" value={signature || ''} />

            <Button mui="true" variant="primary" type="submit" disabled={!amount || !orderIds}>Continue</Button>
        </form>
};



export default VisaCheckoutForm;


// WEBPACK FOOTER //
// ./src/views/order/VisaCheckoutForm.js